import React, { useEffect } from "react";
import NProgress from "../../libraries/progress";
import ViewSwitch from "./ViewSwitch";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import Filter from "./Filter";
import Map from "./Map";
import List from "./List";
import { useDispatch, useSelector } from "react-redux";
import { fetchSensors } from "../../actions/sensorsActions";
import Loader from "../Loader";
import { cropr, gettext } from "../../adapter";
import {
  parseSensors,
  applySearch,
  applyFilters,
  applySorter,
  updateFilterItemCount,
} from "../../utils/sensorUtils";
import LoadError from "../LoadError";

const onVervers = () => {
  window.localStorage.removeItem("timestampCache" + cropr.farm.id);
  window.localStorage.removeItem("sensorsCache" + cropr.farm.id);
  window.location.reload();
};

const SensorOverview = ({ apiUrl }) => {
  const { search } = useLocation();
  let { view, q, direction, sort, filters } = queryString.parse(search);
  if (!view) view = "list";
  const dispatch = useDispatch();

  const sensors = useSelector((state) => {
    const { sensors, filters } = parseSensors(state.sensors.items);
    return { ...state.sensors, items: sensors, filters };
  });

  if (sensors.items.length > 0) {
    // Apply search
    sensors.items = applySearch(q, sensors.items);

    sensors.filters = updateFilterItemCount(
      ["group", "type", "owner", "status", "soilMoistureStatus", "period"],
      sensors.items,
      sensors.filters,
      filters
    );

    // Apply filters
    sensors.items = applyFilters(
      ["group", "type", "owner", "status", "soilMoistureStatus", "period"],
      sensors.items,
      sensors.filters,
      filters
    );

    // Sort sensors
    sensors.items = applySorter(sort, direction, sensors.items);
  }

  useEffect(() => {
    NProgress.start();
    dispatch(fetchSensors(apiUrl));
  }, [dispatch, apiUrl]);

  if (sensors.isFetching === true) {
    return <Loader message={gettext("Loading sensors...")} />;
  }

  if (sensors.loadError) {
    NProgress.done();
    return <LoadError />;
  }

  NProgress.done();

  return (
    <div>
      <div className="l-one-fourth">
        <Filter sensors={sensors.items} filters={sensors.filters} />
      </div>
      <div className="l-three-fourth">
        <div className="panel">
          <h2>
            {gettext("Soil sensors")}{" "}
            <span className="button--outline" onClick={onVervers}>
              {gettext("Refresh")}
            </span>
          </h2>

          <ViewSwitch view={view} />

          {view === "map" ? (
            <Map sensors={sensors.items} className="map large" />
          ) : (
            <List sensors={sensors.items} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SensorOverview;
